import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { GridBox } from "../../components/GridBox/GridBox";
import { View } from "../../components/View/View";
import { AdminViewParams } from "../../routes";
import { AdminFeedTopicByIdQueryResult, useAdminFeedTopicByIdQuery } from "../../schema";
import { AdminViewProps } from "../AdminView/AdminView";
import { ErrorView } from "../ErrorView/ErrorView";
import { LoadingView } from "../LoadingView/LoadingView";
import { AdminFeedTopicDetailsEdit } from "./AdminFeedTopicDetailsEdit";
import { AdminFeedTopicDetailsHeader } from "./AdminFeedTopicDetailsHeader";
import { AdminFeedTopicDetailsInfo } from "./AdminFeedTopicDetailsInfo";

export interface AdminFeedTopicDetailsProps extends AdminViewProps {
  adminFeedTopic: NonNullable<AdminFeedTopicByIdQueryResult["data"]>["adminFeedTopic"];
}

export const AdminFeedTopicDetailsView: React.FC<AdminViewProps> = ({ viewer }) => {
  // get identifier from url parameters
  const { id } = useParams<AdminViewParams>();

  // fetch info
  const { data, loading, error } = useAdminFeedTopicByIdQuery({
    variables: {
      adminFeedTopicId: id ?? "",
    },
  });

  // expecting the id parameter to be provided
  if (!id) {
    return <ErrorView error="Expected identifier is not provided" />;
  }

  // get item info
  const adminFeedTopic = data?.adminFeedTopic;

  // handle error
  if (error) {
    return <ErrorView title="Loading info failed" error={error} />;
  }

  // handle loading
  if (loading || !adminFeedTopic) {
    return <LoadingView />;
  }

  // render details
  return (
    <View pad="half">
      <AdminFeedTopicDetailsHeader adminFeedTopic={adminFeedTopic} viewer={viewer} />
      <GridBox />
      <Routes>
        <Route index element={<AdminFeedTopicDetailsInfo adminFeedTopic={adminFeedTopic} viewer={viewer} />} />
        <Route path="edit" element={<AdminFeedTopicDetailsEdit adminFeedTopic={adminFeedTopic} viewer={viewer} />} />
      </Routes>
    </View>
  );
};
